<template>
  <div class="hvh-flex">
    <div class="hvh-flex align-start mr-2" :class="{ 'mt-5': showExcluded }" v-if="childInd">
      <v-icon small>mdi-subdirectory-arrow-right</v-icon>
      {{ value.criterionOperator.split(' ')[0] }}
    </div>
    <div class="hvh-flex column grow-1 max-w-100">
      <ToggleButton class="font-sm mb-4" :value="value.excluded" :items="includeExcludeOptions" @input="$emit('input', { ...value, excluded: $event })" v-if="showExcluded" />
      <div class="mb-3">
        <div class="hvh-flex" :class="{ 'right-padding': hasRemove }">
          <DPDSearchMulti class="col-12 p-0" :categorySetting="categorySetting" placeholder="Search Name, Description, Creator, or Clinical Criteria" :value="selectedTreeElements" :cohorts="cohorts" @input="toggleSelectedItem" />
          <v-icon class="clickable ml-2 mb-2" @click="$emit('remove', value)" v-if="hasRemove">mdi-close</v-icon>
        </div>
        <div class="v-text-field__details text-xs-left pt-1">
          <div class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">{{ errors }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="hvh-flex wrap" :class="{ 'right-padding': hasRemove }" v-if="isAdvancedCriteria">
        <template v-if="['And', 'Or'].includes(value.criterionOperator)">
          <div class="col-6 p-0 pr-2">
            <v-select :value="value.occurancesNum" :items="occurancesNum" label="Occurring at least" @input="emitValue({ occurancesNum: $event })" outline />
          </div>
          <div class="col-6 p-0 pl-2">
            <v-select :value="value.separatedByMonths" :items="separatedByMonths" label="Separated by" @input="emitValue({ separatedByMonths: $event })" outline />
          </div>
        </template>
        <template v-else>
          <div class="col-6 p-0 pr-2">
            <v-select label="THEN operator type" :value="value.criterionOperator" :items="thenOperators" @input="emitValue({ criterionOperator: $event })" outline />
          </div>
          <div class="col-6 p-0 pl-2">
            <v-text-field :value="value.thenAfterDays" label="Number of Days" :disabled="isAnytime" :rules="checkThenInput" @input="emitValue({ thenAfterDays: parseInt($event) })" type="number" outline />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleButton from '../../common/button/ToggleButton.vue';
import DPDSearchMulti from '../../common/drugProdSelect/dpdSelect/DPDSearchMulti.vue';
export default {
  components: { ToggleButton, DPDSearchMulti },
  props: ['value', 'childInd', 'showExcluded', 'isAdvancedCriteria', 'cohorts'],
  data() {
    return {
      categorySetting: {
        drug: true,
        diagnose: true,
        procedure: true,
        cohort: true,
        physician: true,
      },
      includeExcludeOptions: [
        { text: 'Include', value: false },
        { text: 'Exclude', value: true },
      ],
      // ocurrenceItems: ['1 Time', '2 Times', '3 Times', '4 Times'],
      // separationItems: ['1 Month', '2 Months', '3 Months', '4 Months'],

      thenOperators: [
        { value: 'Then Anytime', text: 'Anytime' },
        { value: 'Then After', text: 'After' },
        { value: 'Then Before', text: 'Within' },
      ],
      occurancesNum: [
        { value: 1, text: '1 Time' },
        { value: 2, text: '2 Times' },
        { value: 3, text: '3 Times' },
        { value: 4, text: '4 Times' },
      ],
      separatedByMonths: [
        { value: 1, text: '1 Month' },
        { value: 2, text: '2 Months' },
        { value: 3, text: '3 Months' },
        { value: 4, text: '4 Months' },
        { value: 5, text: '5 Months' },
        { value: 6, text: '6 Months' },
        { value: 7, text: '7 Months' },
        { value: 8, text: '8 Months' },
        { value: 9, text: '9 Months' },
        { value: 10, text: '10 Months' },
        { value: 11, text: '11 Months' },
        { value: 12, text: '12 Months' },
        { value: 13, text: '13 Months' },
        { value: 14, text: '14 Months' },
        { value: 15, text: '15 Months' },
        { value: 16, text: '16 Months' },
        { value: 17, text: '17 Months' },
        { value: 18, text: '18 Months' }
      ],
    };
  },
  computed: {
    hasRemove() {
      return this.$listeners['remove'];
    },
    checkThenInput() {
      if (!this.isAnytime) {
        if (this.value.thenAfterDays < 0 || this.value.thenAfterDays > 730) {
          return ["Enter the number of days, from 0 to 730"];
        }
      }
      return [];
    },
    isAnytime() {
      return this.value.criterionOperator === 'Then Anytime';
    },
    errors() {
      return !this.value?.selectedTreeElements?.any() ? 'At least one Event is required' : '';
    },
    selectedTreeElements() {
      return (this.value.selectedTreeElements || [])
        .map(f => {
          var event = this.value.eventHashMap[f];
          var eventExists = Object.keys(event || {}).any();
          return eventExists ? { ...event, search: f } : { label: f, search: `error-${f}`, type: 'bad-code' };
        });
    },
  },
  methods: {
    emitValue(obj) {
      this.$emit('input', { ...this.value, ...obj });
    },
    toggleSelectedItem(items) {
      var selectedTreeElements = items.map(f => f.search);
      var eventHashMap = items.reduce((acc, f) => { acc[f.search] = f; return acc; }, {});
      this.emitValue({ selectedTreeElements, eventHashMap });
    },
  },
  watch: {
    'value.criterionOperator'() {
      if (this.isAnytime)
        this.emitValue({ thenAfterDays: 0 });
    },
  },
}
</script>

<style lang="scss" scoped>
.right-padding {
  padding-right: 32px;
}
</style>